import { Box, Typography } from '@mui/material'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useTranslation } from 'react-i18next'
import FavoriteButton from '../../../../../shared/components/buttons/FavoriteButton'
import ShareIcon from '../../../../../shared/components/icons/ShareIcon'
import AdminDetailInfo from '../../../../library/ui/components/AdminDetailInfo'

dayjs.extend(relativeTime)

interface NoveltyDetailContentProps {
  isAdmin: boolean
  noveltySelected: any
  isMobile: boolean
  favoriteState: boolean
  handleFavoriteClick: (id: number) => (state: boolean) => void
}

const NoveltyDetailContent = ({ isAdmin, noveltySelected, isMobile, favoriteState, handleFavoriteClick }: NoveltyDetailContentProps) => {
  const { t } = useTranslation(['global'])

  return isAdmin ? (
    <AdminDetailInfo resourceSelected={noveltySelected} />
  ) : (
    <>
      <Box sx={{ pb: 4 }}>
        <Typography variant={isMobile ? 'h5' : 'h3'} sx={{ fontWeight: 400 }}>
          {noveltySelected.title}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pt: 2 }}>
          <Box>
            <Typography color="text.secondary">{`${dayjs(noveltySelected.created_at).fromNow()}`}</Typography>
            <Typography color="text.secondary" variant="body2">{`${t('writter-by')} : ${noveltySelected.creator.name}`}</Typography>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <FavoriteButton handleClick={handleFavoriteClick(noveltySelected.id)} favoriteState={favoriteState} />
            <ShareIcon
              meta={true}
              visibility={noveltySelected.visibility}
              description=""
              title={noveltySelected.title}
              link={window.location.href}
              multimedia={`${import.meta.env.VITE_AWS_URL}/novelties/${noveltySelected.image_url}`}
              component="button"
              type="news"
            />
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default NoveltyDetailContent
